import React, { Component } from 'react';
import { ArcElement, Chart as ChartJS, ChartOptions, Legend, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { ChartJsDataModel } from '../../../domain/chart/ChartDomains';

ChartJS.register(ArcElement, Tooltip, Legend);

class DonutChartComponent extends Component<Props> {
  public render() {
    const { data, options } = this.props;
    return (
      <div className={'flex w-full h-full px-5 py-5 items-center justify-center'}>
        <Doughnut options={options} data={data}></Doughnut>
      </div>
    );
  }
}

interface Props {
  data: ChartJsDataModel;
  options?: ChartOptions;
}

export default DonutChartComponent;
